<template>
	<modal ref="modal">
		<template #title>Cancel Subscription</template>
		<template #body>
			<div class="form-floating mb-4">
				<select
					v-model="form.product_name"
					id="subscription"
					class="form-select"
					placeholder="Select subscription"
					:class="{ 'is-invalid': form.errors.product_name }"
				>
					<option :value="member.current_rank">
						{{ member.current_rank }}
					</option>
					<option
						v-for="(otherSubscription, index) in otherSubscriptions"
						:key="index"
						:value="index"
					>
						{{ index }}
					</option>
				</select>
				<label class="form-label" for="subscription">Subscription</label>
				<div v-if="form.errors.product_name" class="invalid-feedback">
					{{ form.errors.product_name }}
				</div>
			</div>
			<div class="form-floating mb-4">
				<select
					v-model="form.remarks"
					id="remarks"
					class="form-select"
					placeholder="Select remarks"
					:class="{ 'is-invalid': form.errors.remarks }"
				>
					<option value="Cancelled">Cancelled without refund</option>
					<option value="Refunded">Cancelled with refund</option>
				</select>
				<label class="form-label" for="remarks">Remarks</label>
				<div v-if="form.errors.remarks" class="invalid-feedback">
					{{ form.errors.remarks }}
				</div>
			</div>
			<div v-if="form.remarks === 'Refunded'" class="form-floating mb-4">
				<input
					v-model="form.refunded_amount"
					type="number"
					class="form-control"
					id="refund"
					placeholder="Enter refund amount"
					:class="{ 'is-invalid': form.errors.refunded_amount }"
				/>
				<label class="form-label" for="refund">Amount to refund</label>
				<div v-if="form.errors.refunded_amount" class="invalid-feedback">
					{{ form.errors.refunded_amount }}
				</div>
			</div>
			<div class="form-floating mb-4">
				<textarea
					v-model="form.reason"
					id="reason"
					class="form-control"
					placeholder="Enter reason"
					style="height: 150px"
					:class="{ 'is-invalid': form.errors.reason }"
				></textarea>
				<label class="form-label" for="reason">Reason</label>
				<div v-if="form.errors.reason" class="invalid-feedback">
					{{ form.errors.reason }}
				</div>
			</div>
		</template>
		<template #footer>
			<button
				@click="cancelSubscription"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				Cancel Subscription
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		admin: Object,
		member: Object,
		otherSubscriptions: Object,
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const form = useForm({
			member_id: props.member.counter,
			owner: props.member.email,
			product_name: props.member.current_rank,
			reason: null,
			refunded_amount: null,
			cancelled_by: props.admin.full_name,
			remarks: 'Cancelled',
		})

		const cancelSubscription = () => {
			form.post(route('admin.post.cancel-subscription'), {
				preserveState: true,
				preserveScroll: true,
				onSuccess: () => {
					form.reset()
					toggleModal()
				},
			})
		}

		return {
			form,
			modal,
			toggleModal,
			cancelSubscription,
		}
	},
}
</script>
